module.exports = __webpack_public_path__ + "static/media/class-invite-2.6d63eb5f.PNG";